import { render, staticRenderFns } from "./QColorSvpanel.vue?vue&type=template&id=a72d366a&"
import script from "./QColorSvpanel.vue?vue&type=script&lang=js&"
export * from "./QColorSvpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports